(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
(function() {
  var loading = false;
  var autoLoadObserver = null;

  function getContainer() {
    return document.getElementById('CollectionLoadMore');
  }

  function loadNextPage() {
    var container = getContainer();
    if (loading || !container) return;

    var url = container.getAttribute('data-next-url');
    if (!url) return;

    loading = true;
    var btn = container.querySelector('[data-load-more]');
    var label = container.querySelector('[data-load-more-label]');
    if (btn) btn.setAttribute('disabled', 'disabled');
    if (label) label.textContent = 'Loading...';

    fetch(url)
      .then(function(response) { return response.text(); })
      .then(function(text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');

        // Append the next page's product grid items
        var grid = document.querySelector('#CollectionSection .grid--collection');
        var newItems = doc.querySelectorAll('#CollectionSection .grid--collection > .grid__item');
        newItems.forEach(function(item) {
          grid.appendChild(document.importNode(item, true));
        });

        // Bring across quick shop modals for the newly loaded products
        var section = document.getElementById('CollectionSection');
        doc.querySelectorAll('[id^="QuickShopModal"], .modal--quick-shop').forEach(function(modal) {
          if (modal.id && !document.getElementById(modal.id)) {
            section.appendChild(document.importNode(modal, true));
          }
        });

        // Swap in the fetched page's load-more block (updates count + next URL)
        var newContainer = doc.getElementById('CollectionLoadMore');
        if (newContainer) {
          container.replaceWith(document.importNode(newContainer, true));
        } else {
          container.remove();
        }

        reinitProductGrid();
        watchForAutoLoad();
      })
      .catch(function(err) {
        console.error('[Load more] Failed to fetch next page:', err);
        if (btn) btn.removeAttribute('disabled');
        if (label) label.textContent = 'Load more products';
      })
      .finally(function() {
        loading = false;
      });
  }

  // Re-hook theme behaviours (quick shop, etc.) onto newly added grid items.
  // These hooks vary slightly between Impulse versions, so each is guarded.
  function reinitProductGrid() {
    if (typeof window.theme === 'undefined') return;
    if (typeof theme.initQuickShop === 'function') theme.initQuickShop();
    if (typeof theme.reinitProductGridItem === 'function') theme.reinitProductGridItem();
  }

  function watchForAutoLoad() {
    if (autoLoadObserver) {
      autoLoadObserver.disconnect();
      autoLoadObserver = null;
    }

    var container = getContainer();
    if (!container) return;
    if (container.getAttribute('data-auto-scroll') !== 'true') return;
    if (!container.getAttribute('data-next-url')) return;
    if (!('IntersectionObserver' in window)) return;

    autoLoadObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) loadNextPage();
      });
    }, { rootMargin: '600px 0px' });

    autoLoadObserver.observe(container);
  }

  function init() {
    // Click handler is delegated so it survives the block being replaced
    document.addEventListener('click', function(evt) {
      if (evt.target.closest('[data-load-more]')) loadNextPage();
    });

    watchForAutoLoad();

    // Impulse's AJAX filtering/sorting replaces the section contents,
    // so re-attach the auto-load observer whenever that happens.
    var section = document.getElementById('CollectionSection');
    if (section && 'MutationObserver' in window) {
      var wrapper = section.closest('.shopify-section') || section.parentNode;
      new MutationObserver(function() {
        watchForAutoLoad();
      }).observe(wrapper, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
